// Norwegian Bokmal

const lang = {
  gateMediaPreviewHeader: 'Kan hende du også liker',
  loadmore: 'Vis mer',
  nextMedia: 'Neste medier',
  previousMedia: 'Forrige medier',
  closePost: 'Lukk innlegg',
  nextPost: 'Neste innlegg',
  previousPost: 'Forrige innlegg',
  outOfStock: 'Utsolgt',
  numberOfReviews(n) {
    return n === 1 ? 'anmeldelse' : 'anmeldelser'
  },
  reportFormField: 'Vennligst skriv inn en melding',
  reportPost: 'Rapporter innlegg',
  reportFormTitle: 'Vil du rapportere dette bildet?',
  reportFormDetails:
    'Hvis du tror at dette bildet er upassende, ulovlig eller krenker andres rettigheter, kan du rapportere innholdet. Hvis du rapporterer bildet/teksten, vil innholdsmoderatorene bli varslet og riktige tiltak iverksatt.',
  reportFormMessagePlaceholder: 'Oppgi årsaken til rapporten din',
  reportFormMessageLabel: 'Melding',
  reportFormEmailLabel: 'Din e-post',
  reportFormSubmitButtonText: 'Send rapport',
  reportFormCancelButtonText: 'Avbryt',
  reportFormSentTitle: 'Takk for din rapport!',
  reportFormSentCloseButtonText: 'Lukk',
  cardAndTileAriaLabel:
    'Nedenfor er en liste over innlegg fra kontoer på ulike sosiale medieplattformer',
  carouselAriaLabel: 'Nedenfor vises en karusell med innlegg fra kontoer på ulike sosiale medier',
  singleAriaLabel: 'Nedenfor er et innlegg fra en konto på sosiale medier',
  poweredBy: 'Drevet av Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publisert på ${date}` : ''
    const createdByString = userName ? ` fra ${userName}` : ''
    return `Bilde${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Last opp media',
  openTheGate: 'Åpne dialogboksen',
}

export default lang
